import React from 'react';
import { bool } from 'prop-types';
import ClassNames from 'classnames';
import Icon from '../../../icon/Icon';
import LoadingSpinner from '../../../.deprecated/loading_spinner/LoadingSpinner';

import './SelectStatusIcon.scss';

const SelectStatusIcon = props => {
  const { active, disabled, invalid, loading } = props;

  const componentClassNames = ClassNames(
    'select-status-icon',
    active && 'select-status-icon--active',
    invalid && 'select-status-icon--invalid',
    disabled && 'select-status-icon--disabled'
  );

  return loading ? (
    <LoadingSpinner color="gray" size="small" className="select-status-icon" />
  ) : (
    <Icon icon="caretDown" className={componentClassNames} />
  );
};

SelectStatusIcon.propTypes = {
  active: bool.isRequired,
  disabled: bool.isRequired,
  invalid: bool.isRequired,
  loading: bool.isRequired
};

export default SelectStatusIcon;
